/**
 * 分母と分子を受け取ってパーセントで返す
 * @param denominator 分母
 * @param numerator 分子
 * @returns パーセント
 */
export const calcPercentage = (denominator: number, numerator: number) => {
  if (denominator === 0) return 0;
  const percentage = Math.round((numerator / denominator) * 100);
  if (percentage > 100) return 100;
  if (percentage < 0) return 0;
  return percentage;
};
